import { render, staticRenderFns } from "./order-customer-fields.vue?vue&type=template&id=1272ad24&"
import script from "./order-customer-fields.vue?vue&type=script&lang=js&"
export * from "./order-customer-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports